import React, { FC } from 'react'
import AppStore from 'src/images/svg/appstore.svg'
import GooglePlay from 'src/images/svg/googleplay.svg'

interface IStoreButtonsProps {
  className?: string
}

const StoreButtons: FC<IStoreButtonsProps> = ({ className = '' }) => (
  <div className={`flex flex-row items-center gap-4 ${className}`}>
    <a
      href="https://apps.apple.com/pl/app/rosa-rules-of-sport-app/id1622562179"
      target="_blank"
      rel="noreferrer"
      className="inline-block shrink-0 h-extra-huge lg:h-huge xl:h-extra-huge"
    >
      <img src={AppStore} alt="ROSA App Store" className="h-extra-huge lg:h-huge xl:h-extra-huge w-auto block" />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=pl.mamf.rosa.example&hl=pl&gl=US"
      target="_blank"
      rel="noreferrer"
      className="inline-block shrink-0 h-extra-huge lg:h-huge xl:h-extra-huge"
    >
      <img src={GooglePlay} alt="ROSA Google Play" className="h-extra-huge lg:h-huge xl:h-extra-huge w-auto block" />
    </a>
  </div>
)

export default StoreButtons